<template>
  <div id="home-left" ref="appRef">
    <div class="host-body">
      <div class="host-body-left">
        <div class="top-box">
          <div class="wire"></div>
          <div class="left1">
            <div class="dataVF">
              <div class="box-title">
                <!-- {{ dateYear }} &nbsp; -->
                <span class="distance">学生总人数</span>
              </div>
              <div class="student-num">{{ studentTotal }}</div>
              <img src="@/assets/images/leftTime2.png" class />
              <div class="num-bottom">
                <span>10</span>
                <span>20</span>
                <span>30</span>
                <span>40</span>
                <span>50</span>
                <span>60</span>
                <span>70</span>
                <span>80</span>
                <span>90</span>
                <span>100</span>
              </div>
            </div>
            <div class="dataVF">
              <div class="box-title">本学年入学学生人数</div>
              <dv-digital-flop :config="thisYear" />
            </div>
          </div>
        </div>
        <div class="center">
          <div class="center-left">
            <div class="center-left-1">
              <img src="@/assets/images/leftGirl.png" class="imgGirl" />
              <img src="@/assets/images/leftMan.png" class="imgMale" />
              <div class="sex-man-10">
                <div
                  class="sex-girl-10"
                  :style="{ width: girlRate + '%' }"
                ></div>
              </div>

              <div>
                <div class="box-title">男女学生比例</div>
                <leftChart2
                  :Ldata="studentSexData"
                  class="leftCenter"
                ></leftChart2>
              </div>
            </div>
            <div class="center-left-2">
              <div class="box-title">男女教师比例</div>
              <leftChart3 :cdata="teacherSexData" />
            </div>
          </div>

          <div class="center-right">
            <div>
              <div class="box-title">学生障碍类型占比</div>
            </div>
            <leftChart8 class="leftCenterB_2" :RBdata="zAidata"></leftChart8>
          </div>
        </div>
      </div>
      <div class="host-body-right">
        <div class="aRightTop">
          <div class="rightFont">学生障碍类型占比</div>
          <leftChart6 :R1Adata="zAidata2" class="appA"></leftChart6>
        </div>
        <div class="aRightBottom">
          <div class="rightFontSize">各学段学生人数统计</div>
          <leftChart5
            :LBdata="numsBySection"
            class="bottomB_dataB_2"
          ></leftChart5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftChart2 from '_c/echart/left/leftChart2.vue';
import leftChart3 from '_c/echart/left/leftChart3.vue';
import leftChart5 from '_c/echart/left/leftChart5.vue';
import leftChart6 from '_c/echart/left/leftChart6.vue';
// import leftChart7 from "_c/echart/left/leftChart7.vue";
import leftChart8 from '_c/echart/left/leftChart8.vue';
// import drawMixin from '@/utils/drawMixin';
// import { eduStageMap } from '@/utils/index.js';
import {
  getStudentTotal,
  getStudentYear,
  getTeacherTotal,
  getStudentNumBySection,
  getStudentDisability,
  getStudentDisability2
} from '@/api/left.js';

export default {
  // mixins: [drawMixin],
  components: {
    leftChart2,
    leftChart3,
    leftChart5,
    leftChart6,
    // leftChart7,
    leftChart8
  },
  data() {
    return {
      studentTotal: 0,
      thisYear: {
        number: [0],
        content: '{nt}',
        style: {
          fontSize: 80,
          fill: '#fff'
        }
      },
      manRate: 0,
      girlRate: 0,
      studentSexData: {
        data: [
          // { value: 0, name: "男",count:'0' },
          // { value: 0, name: "女",count:'0'  }
        ]
      },
      teacherSexData: {
        total: '0',
        data: [
          { value: 0, name: '男' },
          { value: 0, name: '女' }
        ]
      },
      zAidata: {
        data: [
          // {
          //   value: 16,
          //   name: '多重障碍'
          // },
          // {
          //   value: 25,
          //   name: '智力障碍'
          // },
          // {
          //   value: 20,
          //   name: '精神'
          // },
          // {
          //   value: 24,
          //   name: '视力'
          // },
          // {
          //   value: 20,
          //   name: '言语与语言障碍'
          // }
        ]
      },
      zAidata2: {
        legends: [],
        xAxisData: [],
        yAxisData: []
      },
      numsBySection: {
        xAxisData: [],
        seriesData: []
        // xAxisData: ['学校1', '学校2', '学校3', '学校4', '学校5', '学校6'],
        // seriesData: [254, 324, 654, 454, 757, 211]
      }
    };
  },

  mounted() {
    // this.initData();
  },
  created() {
    this.initData();
  },
  methods: {
    /**
     * 初始化数据
     */
    initData() {
      this.getStudentTotalNum();
      this.getStudentYearNum();
      this.getTeacherTotalNum();
      this.getStudentDisabilityCircle();
      this.getStudentDisabilityBar();
      this.getStudentNumBySection();
    },
    // 学生总人数
    async getStudentTotalNum() {
      const { data } = await getStudentTotal();
      this.studentTotal = data.allCount;
      if (data.manCount === 0 && data.womanCount === 0) {
        return;
      }
      this.girlRate = parseInt((data.womanCount / data.allCount) * 100);
      this.manRate = 100 - this.girlRate;
      this.studentSexData = {
        data: [
          { value: this.manRate, name: '男', count: data.manCount },
          { value: this.girlRate, name: '女', count: data.womanCount }
        ]
      };
    },
    // 学生今年人数
    async getStudentYearNum() {
      const { data } = await getStudentYear();
      this.thisYear = {
        number: [data.allCount],
        content: '{nt}',
        style: {
          fontSize: 80,
          fill: '#fff'
        }
      };
    },
    // 教师总人数
    async getTeacherTotalNum() {
      const { data } = await getTeacherTotal();
      if (data.manCount === 0 && data.womanCount === 0) {
        return;
      }
      this.teacherNum = data.allCount + '';
      this.teacherSexData = {
        total: data.allCount,
        data: [
          { name: '男', value: data.manCount },
          { name: '女', value: data.womanCount }
        ]
      };
    },

    //学生障碍类型占比（环状图）
    async getStudentDisabilityCircle() {
      const { data } = await getStudentDisability();
      if (!Array.isArray(data)) return;
      data.forEach((elem) => {
        elem.name = elem.type;
        elem.value = elem.count;
        delete elem.type;
        delete elem.count;
      });
      this.zAidata.data = data;
    },

    //学生障碍类型占比（分学段）
    async getStudentDisabilityBar() {
      const { data } = await getStudentDisability2();
      // console.log(data, '学生障碍类型占比（分学段）');

      // 演示数据，千万别删，有用
      // const data = [
      //   {
      //     count: 1,
      //     time: '初中',
      //     type: '多重障碍'
      //   },
      //   {
      //     count: 27,
      //     time: '初中',
      //     type: '视力'
      //   },
      //   {
      //     count: 5,
      //     time: '学前',
      //     type: '视力'
      //   },
      //   {
      //     count: 5,
      //     time: '小学 中年级',
      //     type: '多重障碍'
      //   },
      //   {
      //     count: 3,
      //     time: '小学 中年级',
      //     type: '智力障碍'
      //   },
      //   {
      //     count: 18,
      //     time: '小学 中年级',
      //     type: '视力'
      //   },
      //   {
      //     count: 5,
      //     time: '小学 中年级',
      //     type: '多重障碍'
      //   },
      //   {
      //     count: 1,
      //     time: '小学 低年级',
      //     type: '多重障碍'
      //   },
      //   {
      //     count: 20,
      //     time: '小学 低年级',
      //     type: '视力'
      //   },
      //   {
      //     count: 25,
      //     time: '小学 高年级',
      //     type: '视力'
      //   },
      //   {
      //     count: 6,
      //     time: '职高',
      //     type: '多重障碍'
      //   },
      //   {
      //     count: 22,
      //     time: '职高',
      //     type: '智力障碍'
      //   },
      //   {
      //     count: 29,
      //     time: '职高',
      //     type: '视力'
      //   }
      // ];

      let newData1 = data.filter((item) => item.type !== 'total');
      // newData1.forEach((item) => {
      //   item.time = eduStageMap[item.time];
      //   return item;
      // });

      let newData = newData1.reduce((acc, cur) => {
        let obj = acc.find(
          (item) => item.time === cur.time && item.type === cur.type
        );
        if (obj) {
          obj.count += cur.count;
        } else {
          acc.push(cur);
        }
        return acc;
      }, []);

      let legends = [];
      let xAxisData = [];
      // let yAxisData = [];

      for (let i = 0; i < newData.length; i++) {
        if (!legends.includes(newData[i].type)) {
          legends.push(newData[i].type);
        }

        if (!xAxisData.includes(newData[i].time)) {
          xAxisData.push(newData[i].time);
        }
      }

      const xAxisOrderMap = {
        学前: 0,
        '小学 低年级': 1,
        '小学 中年级': 2,
        '小学 高年级': 3,
        小学: 4,
        初中: 5,
        高中: 6,
        职高: 7,
        大学: 8
      };

      // 对x轴数据进行排序
      xAxisData.sort((a, b) => xAxisOrderMap[a] - xAxisOrderMap[b]);

      // 创建一个包含x轴值和索引的映射对象
      const xAxisIndexMap = {};
      xAxisData.forEach((xValue, index) => {
        xAxisIndexMap[xValue] = index;
      });

      // 根据新的x轴顺序，重组y轴数据
      const updatedYAxisData = [];
      for (let i = 0; i < legends.length; i++) {
        let seriesData = [];
        for (let j = 0; j < xAxisData.length; j++) {
          const xValue = xAxisData[j];
          const xIndex = xAxisIndexMap[xValue];
          let count = 0;
          for (let k = 0; k < newData.length; k++) {
            if (newData[k].type === legends[i] && newData[k].time === xValue) {
              count = newData[k].count;
              break;
            }
          }
          seriesData[xIndex] = count;
        }
        updatedYAxisData.push({
          seriesName: legends[i],
          seriesData: seriesData
        });
      }

      this.zAidata2 = {
        legends: legends,
        xAxisData: xAxisData,
        yAxisData: updatedYAxisData
      };
    },
    // 学生今年人数 按学校分
    async getStudentNumBySection() {
      const { data } = await getStudentNumBySection();
      if (!Array.isArray(data)) return;
      this.numsBySection.xAxisData = data.map((item) => item.time);
      this.numsBySection.seriesData = data.map((item) => item.count);
    }
  }
};
</script>

<style lang="scss" scoped>
#home-left {
  width: 1920px;
  height: 1080px;
  overflow: hidden;
  color: #fff;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
  // transform-origin: left top;
}
.host-body {
  display: flex;
  padding-left: 39px;
  padding-top: 86px;
  .host-body-left {
    position: relative;
    .top-box {
      width: 1157px;
      height: 280px;
      background: url('~@/assets/images/left-top-bg.png') no-repeat;
    }
  }
  .host-body-right {
    flex: 1;
    margin-left: 30px;
    position: relative;
  }
}
.left1 {
  position: absolute;
  left: 0;
  top: 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  padding-top: 15px;
  color: #2accff;
  // align-items: center;
}
.leftCenter {
  position: absolute;
  left: 0;
  top: 10px;
  width: 100%;
}

.imgGirl {
  width: 70px;
  height: 70px;
  position: absolute;
  left: 40px;
  top: 130px;
}
.imgMale {
  width: 70px;
  height: 70px;
  position: absolute;
  right: 40px;
  top: 130px;
}
.sex-man-10 {
  position: absolute;
  left: 157.5px;
  bottom: 20px;
  width: 25px * 10;
  height: 25px;
  background: url('~@/assets/images/leftMan2.png');
}
.sex-girl-10 {
  position: absolute;
  left: 0px;
  top: -1px;
  width: 25%;
  height: 25px;
  background: url('~@/assets/images/leftGirl2.png');
  background-color: #0b2251;
}
.wire {
  position: absolute;
  top: 52px;
  left: 50%;
  width: 1px;
  height: 177px;
  border: 1px solid #4cccff;
}
.dataVF {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .imgVF {
    padding-top: 50px;
  }
}
.distance {
  padding-left: 20px;
}
.num-bottom {
  margin-top: -30px;
  width: 310px;
  height: 30px;
  font-size: 19px;
  color: #246ee3;
  span {
    display: inline-block;
    margin-right: 8px;
  }
  span:nth-child(1) {
    transform: rotate(20deg) translateY(-15px);
  }
  span:nth-child(2) {
    transform: rotate(10deg) translateY(-8px);
  }
  span:nth-child(3) {
    transform: rotate(8deg) translateY(-3px);
  }
  span:nth-child(4) {
    transform: rotate(5deg) translateY(-1px);
  }
  span:nth-child(5) {
    transform: rotate(1deg) translateY(1px);
  }
  span:nth-child(6) {
    transform: rotate(-1deg) translateY(1px);
  }
  span:nth-child(7) {
    transform: rotate(-5deg) translateY(-1px);
  }
  span:nth-child(8) {
    transform: rotate(-8deg) translateY(-3px);
  }
  span:nth-child(9) {
    transform: rotate(-10deg) translateY(-6px);
  }
  span:nth-child(10) {
    transform: rotate(-20deg) translateY(-13px);
  }
}
.student-num {
  margin-top: 30px;
  margin-bottom: -25px;
  font-size: 65px;
  line-height: 65px;
  font-weight: 600;
  color: #09d5c6;
}
.box-title {
  width: 100%;
  padding-top: 40px;
  font-size: 26px;
  font-weight: 400;
  color: #17caf0;
  text-align: center;
}

.center-left {
  margin-top: 6px;
  width: 565px;
  height: 346px + 328px;
  margin-right: 13px;
}
.center-left-1 {
  width: 100%;
  height: 340px;
  // 框.png
  background: url('~@/assets/images/background1.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.center-left-2 {
  margin-top: 10px;
  width: 100%;
  height: 340px;
  // 框.png
  background: url('~@/assets/images/background2.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
}
.center-right {
  margin-top: 20px;
  width: 566px;
  height: 346px + 328px;
  margin-left: 13px;
  // 框.png
  background: url('~@/assets/images/center-left-border.png') no-repeat;
  background-size: 100% 100%;
}

.center {
  display: flex;
}
.bottom {
  display: flex;
  margin-top: 12px;
  .bottomLeft {
    width: 564px;
    height: 336px;
    background: url('~@/assets/images/background3.png') no-repeat;
    margin-right: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    // flex-direction: column;
  }
  .bottomRight {
    margin-left: 13px;
    width: 564px;
    height: 336px;
    background: url('~@/assets/images/background4.png') no-repeat;
    position: relative;
  }
  .bottomRightA {
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
  }
}
.bottomLeft_A {
  width: 382px;
  height: 85px;
  background: url('~@/assets/images/background5.png') no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.bottomLeft_B {
  width: 382px;
  height: 85px;
  background: url('~@/assets/images/background6.png') no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.green {
  color: #51ef6b;
}
.yellow {
  color: #fecb00;
}
.bottomLeft_B_font {
  font-size: 24px;
  padding-bottom: 5px;
}
.bottomLeft_B_fontSise {
  font-size: 19px;
}
.bottomLeft_font {
  padding-top: 47px;
  color: #2accff;
  font-size: 25px;
  text-align: center;
}
.aRightTop {
  width: 666px;
  height: 478px;
  background: url('~@/assets/images/rightA.png') no-repeat;
  .appA {
    margin-top: 20px;
  }
}
.aRightBottom {
  margin-top: 18px;
  width: 666px;
  height: 478px;
  background: url('~@/assets/images/rightBottom.png') no-repeat;
}
.imgRightA {
  width: 100%;
  height: 480px;
  position: relative;
}
.rightA_1 {
  position: absolute;
  left: 0;
  top: 0;
  // width: ;
}
.imgRightB {
  width: 100%;
  position: relative;
}
.rightFont {
  padding-top: 52px;
  color: #2accff;
  font-size: 26px;
  width: 100%;
  text-align: center;
}
.rightFontSize {
  color: #2accff;
  font-size: 26px;
  padding-top: 52px;
  text-align: center;
}
</style>
